import { fill_len, xy_len } from "#internal"
import type { ResolvedSymmetry } from "#public"
import type { FillStrategyData } from "#public"

/**
 * Mirrors Python `FillStrategy.x_symmetry` on a best-fill result — uses
 * `xy_len` (product) semantics matching the canonical
 * `strategies/fill/Geometry.ts` `x_symmetry`, NOT `BestFill`'s internal
 * `xy_bool`-based variant.
 */
const x_symmetry = (s: FillStrategyData): boolean => {
  if (fill_len(s) <= 0) return true
  return Boolean(
    s.symmetric_grow.x ||
    (s.subjects.x % 2 === 0 && !xy_len(s.subjects_flipped.x) && s.subjects_flipped.y.x % 2 === 0)
  )
}

/** Mirrors Python `FillStrategy.get_used_symmetry` over a best-fill result. */
export const FillUsedSymmetry = (s: FillStrategyData): ResolvedSymmetry => {
  if (!s.use_symmetry) return null
  if (s.use_symmetry === "x" || s.use_symmetry === "y") return s.use_symmetry
  return x_symmetry(s) ? "x" : "y"
}
